/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/common/NavigationBarConfiguration.yaml
export const NavigationBarModeValues = ['DARK', 'LIGHT', 'HIDDEN'];
//# sourceMappingURL=NavigationBarConfiguration.js.map